import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Paper,
  Chip,
  CircularProgress,
} from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import { useNavigate } from 'react-router-dom';

const HEADER_BG = '#1e40af';
const HEADER_BORDER = '#60A5FA';

export default function ImageCredits() {
  const navigate = useNavigate();

  return (
    <Box style={{}}>
      <Box
        sx={{
          height: 72,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: HEADER_BG,
          color: 'white',
          borderBottom: `1px solid ${HEADER_BORDER}`,
        }}
      >
        <Stack direction="row" spacing={1.25} alignItems="center">
          <img src="/ssiconfull.png" alt="logo" style={{ width:'160px'}} />
        </Stack>

        <Button
          variant="outlined"
          onClick={() => navigate('/')}
          sx={{
            color: 'white',
            borderColor: 'rgba(255,255,255,0.35)',
            textTransform: 'none',
            bgcolor: 'rgba(255,255,255,0.06)',
            '&:hover': {
              borderColor: 'rgba(255,255,255,0.5)',
              bgcolor: 'rgba(255,255,255,0.12)',
            },
          }}
        >
          Home
        </Button>
      </Box>
      <Box sx={{px:2}}>
      <h2>Image Credits</h2>
        <p><a href="https://commons.wikimedia.org/wiki/File:Medical_X-Ray_imaging_AGL02_nevit.jpg">© Nevit Dilmen</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:14-02-Erguss_im_Stehen.png">Hellerhoff</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:ST_elevation_myocardial_infarction_ECG_(cropped).jpg">Various</a>, <a href="https://creativecommons.org/licenses/by/4.0">CC BY 4.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Normal_ECG_from_a_66-year_old_British_male_subject_2019.jpg">Rodhullandemu</a>, Public domain, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:ECG_Atrial_Fibrillation.svg">Ewingdo; vectorised and touched up by Marnanel</a>, <a href="https://creativecommons.org/licenses/by-sa/4.0">CC BY-SA 4.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Normal_PA_chest_x-ray_(5414485536).jpg">Yale Rosen from USA</a>, <a href="https://creativecommons.org/licenses/by-sa/2.0">CC BY-SA 2.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Cardiomegally.PNG">James Heilman, MD</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Chest_X-ray_in_influenza_and_Haemophilus_influenzae.jpg">Mikael Häggström, M.D. Author info - Reusing images- Conflicts of interest:  NoneMikael Häggström, M.D.Consent note: Written informed consent was obtained from the individual, including online publication.</a>, CC0, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Atrial_flutter_with_4-1_AV_block.png">Ksheka (talk) (Uploads)</a>, <a href="http://creativecommons.org/licenses/by-sa/3.0/">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Hyperkalemia_ECG.jpg">Dr. Michael-Joseph F. Agbayani and Dr. Eddieson Gonzales (Manila, Philippines)</a>, <a href="https://creativecommons.org/licenses/by/4.0">CC BY 4.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:ECG_001.jpg">http://en.wikipedia.org/wiki/User:Glenlarson</a>, <a href="http://creativecommons.org/licenses/by-sa/3.0/">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Duenndarmileus_Chiasamen_-_Roe_-_0001.jpg">Hellerhoff</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:LargeBowelObsFlat2008.jpg">James Heilman, MD</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Medical_X-Ray_imaging_MEO05_nevit.jpg">© Nevit Dilmen</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Medical_X-Ray_imaging_MTN06_nevit.jpg">© Nevit Dilmen</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:LowKECG.JPG">James Heilman, MD</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:ARDSSevere.png">James Heilman, MD</a>, <a href="https://creativecommons.org/licenses/by-sa/4.0">CC BY-SA 4.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Medical_X-Ray_imaging_MNI06_nevit.jpg">© Nevit Dilmen</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
        <p><a href="https://commons.wikimedia.org/wiki/File:Medical_X-Ray_imaging_QZG06_nevit.jpg">© Nevit Dilmen</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>, via Wikimedia Commons</p>
      </Box>
    </Box>
  );
}